module.exports = __webpack_public_path__ + "static/41-7273e746140a355f1e3669da7a5c46cd.png";